import {Component} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AuthenticationService, RoutingService, AppToastrService} from 'app/services';
import {STATE_NAMES, EMAIL_PATTERN, PASSWORD_PATTERN} from 'app/common';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordPageComponent {
  form: FormGroup;
  passwordCtrl: FormControl;
  passwordConfirmCtrl: FormControl;
  isSubmitting: boolean;
  errorMessage: string;

  constructor(private fb: FormBuilder,
              private routingService: RoutingService,
              private toastr: AppToastrService,
              private authenticationService: AuthenticationService) {
    this.passwordCtrl = fb.control('', [Validators.required, Validators.pattern(PASSWORD_PATTERN)]);
    this.passwordConfirmCtrl = fb.control('', [Validators.required, Validators.pattern(PASSWORD_PATTERN)]);
    this.form = fb.group({
      password: this.passwordCtrl,
      passwordConfirm: this.passwordConfirmCtrl,
    });
  }

  onSubmit() {
    try {
      this.errorMessage = null;
      const data = {
        password: this.passwordCtrl.value,
        confirm_password: this.passwordConfirmCtrl.value
      };
      if (this.form.valid && !this.isSubmitting && data.password === data.confirm_password) {
        this.isSubmitting = true;
        this.authenticationService.changePassword(data, this.routingService.params.token).subscribe((res) => {
          if (res) {
            this.isSubmitting = false;
            this.toastr.showToast({title: 'Ваш пароль успешно изменен. Войдите в систему.'});
            this.routingService.go(STATE_NAMES.login);
          }
        }, (err) => {
          const defaultMessage = 'Что-то пошло не так. Пожалуйста, попробуйте еще раз или обратитесь к системному администратору.';
          this.errorMessage = err && err.error && err.error.message ? err.error.message : defaultMessage;
          this.isSubmitting = false;

        });
      }
    } catch (e) {
      this.errorMessage = 'Что-то пошло не так. Пожалуйста, попробуйте еще раз или обратитесь к системному администратору.';
      this.isSubmitting = false;
    }
  }
}
